import React, { useEffect, useState } from 'react';

const Profile = () => {
  const [profilePhoto, setProfilePhoto] = useState<string | null>(null);
  const [isUploaded, setIsUploaded] = useState<boolean>(false);

  // Load profile photo from localStorage on initial render
  useEffect(() => {
    const storedPhoto = localStorage.getItem('profilePhoto');
    if (storedPhoto) {
      setProfilePhoto(storedPhoto);
      setIsUploaded(true);  // Ensure "Edit" button shows if photo exists
    }
  }, []);

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setProfilePhoto(base64String);  // Display image instantly
        setIsUploaded(false); // Show "Upload" button
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    if (profilePhoto) {
      localStorage.setItem('profilePhoto', profilePhoto);
      setIsUploaded(true);  // Switch to "Edit" mode after saving
      window.dispatchEvent(new Event('profilePhotoUpdated')); // Inform other components (like Navbar)
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Profile</h1>
      <div className="flex flex-col items-center">
        {profilePhoto ? (
          <img
            src={profilePhoto}
            alt="Profile"
            className="h-32 w-32 rounded-full mb-4"
          />
        ) : (
          <div className="h-32 w-32 rounded-full bg-gray-200 mb-4 flex items-center justify-center">
            
          </div>
        )}

        <label htmlFor="photoUpload" className="sr-only">Upload Photo</label>
        <input
          id="photoUpload"
          type="file"
          accept="image/*"
          onChange={handlePhotoUpload}
        />

        {!isUploaded ? (
          <button
            onClick={handleUploadClick}
            className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 mt-4"
          >
            Upload
          </button>
        ) : (
          <button
            onClick={() => document.getElementById('photoUpload')?.click()}
            className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 mt-4"
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
};

export default Profile;
